<script>
import Vue from 'vue'
import Vuetify from 'vuetify'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)
Vue.use(Vuetify)

export default {
  props: {
    tableContacts: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      showModal: false,
      dialog: false,
      dialogDelete: false,
      municipio: [],
    };
  },

 computed: {

      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },

    },

  mounted() {
  axios
  .get("https://bdd7w9ysj6.execute-api.us-west-1.amazonaws.com/app/municipios", ) 
  .then(function(response){
  this.response = response.data;
   console.log(response)
  });
},


  watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
    },

 methods: {
  sortTable(n) {
  var table, rows, switching, i, x, y, shouldSwitch, dir, switchcount = 0;
  table = document.getElementById("myTable2");
  switching = true;
  // Set the sorting direction to ascending:
  dir = "asc";
  /* Make a loop that will continue until
  no switching has been done: */
  while (switching) {
    // Start by saying: no switching is done:
    switching = false;
    rows = table.rows;
    /* Loop through all table rows (except the
    first, which contains table headers): */
    for (i = 1; i < (rows.length - 1); i++) {
      // Start by saying there should be no switching:
      shouldSwitch = false;
      /* Get the two elements you want to compare,
      one from current row and one from the next: */
      x = rows[i].getElementsByTagName("TD")[n];
      y = rows[i + 1].getElementsByTagName("TD")[n];
      /* Check if the two rows should switch place,
      based on the direction, asc or desc: */
      if (dir == "asc") {
        if (x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) {
          // If so, mark as a switch and break the loop:
          shouldSwitch = true;
          break;
        }
      } else if (dir == "desc") {
        if (x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()) {
          // If so, mark as a switch and break the loop:
          shouldSwitch = true;
          break;
        }
      }
    }
    if (shouldSwitch) {
      /* If a switch has been marked, make the switch
      and mark that a switch has been done: */
      rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
      switching = true;
      // Each time a switch is done, increase this count by 1:
      switchcount ++;
    } else {
      /* If no switching has been done AND the direction is "asc",
      set the direction to "desc" and run the while loop again. */
      if (switchcount == 0 && dir == "asc") {
        dir = "desc";
        switching = true;
      }
    }
  }
}

},

     editItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.desserts.splice(this.editedIndex, 1)
        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.desserts[this.editedIndex], this.editedItem)
        } else {
          this.desserts.push(this.editedItem)
        }
        this.close()
      },

}
</script>

<template>
  <div class="table-responsive mb-0">
 
    <table class="table table-centered table-nowrap align-middle" id="myTable2">
      <thead class="table-light">
        <tr>
          <th class="align-middle"> <button class="botontabla" v-on:click="sortTable(0)"># Tarjeta</button> </th>
          <th class="align-middle"> <button class="botontabla" v-on:click="sortTable(1)">Contacto</button> </th>
          <th class="align-middle"> <button class="botontabla" v-on:click="sortTable(2)">Teléfono</button> </th>
          <th class="align-middle"> <button class="botontabla" v-on:click="sortTable(3)">Fecha de Creación</button> </th>
          <th class="align-middle"> <button class="botontabla" v-on:click="sortTable(4)">Ùltima Actualización</button> </th>
          <th class="align-middle"><i class='bx bx-dots-vertical-rounded'></i></th>
        </tr>
      </thead>
      <tbody >
      
        <tr v-for="data in tableContacts" :key="data.id_tarjeta">
          <td>
            <a href="javascript: void(0);" class="text-body fw-bold">
              {{ data.id_tarjeta }}</a>
          </td>
          <td>{{ data.nombre }} {{ data.apellido_materno }} {{ data.apellido_paterno }}</td>
          <td>{{ data.fecha_creacion }}</td>
          <td>{{ data.fecha_modificacion }}</td>
          <td>
<div class="row ">
			<div class="col-sm-1">
         <router-link to="/ActualizaMunicipio">
<button
   type="button"
   class=" btn-sm btn-rounded botontabla"
   @click="$bvModal.show(data.total)"
 >
   <i style="color: #09A5C7;"  class='bx bxs-pencil'></i>
 </button>
  </router-link>
      </div>
<div class="col-sm-1">
              <button
                type="button"
                class=" btn-sm btn-rounded botontabla"
               @click="$bvModal.show(data.id)" >
                <i  style="color: #E73484;"  class='bx bx-trash'></i>
              </button>
               </div>
                </div>

          </td>

          <b-modal :id="data.id" title="Eliminar registro" centered>
            <b-modal-title class="text-h5"> ¿Estás seguro de que quieres eliminar este registro? 
              </b-modal-title>      
          </b-modal>


        </tr>
      </tbody>
    </table>
  </div>
  <!-- end table -->
</template>

<style>

.botontabla{
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
}

</style>
